<template>
  <Slideover :visible="visible">
    <header class="px-2 py-3 sm:px-6 bg-green-600 text-white">
      <div class="flex items-start justify-between space-x-3">
        <h2 class="text-lg leading-7 font-medium">
          {{ title }}: {{ this.itemToBeCancelled.SKU }}
        </h2>
        <div class="h-7 flex items-center">
          <button
            type="button"
            aria-label="Close panel"
            @click="toggleSlideover()"
            class="text-green-300 hover:text-white transition ease-in-out duration-150"
          >
            <icon set="solid" name="x" class="flex-shrink-0 m-1 h-5 w-5" />
          </button>
        </div>
      </div>
    </header>

    <!-- Main -->
    <div class="flex flex-col py-3 px-2 mx-4 space-y-4">
      <p>You are about to DELETE the following item:</p>

      <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
        <table class="min-w-full divide-y divide-gray-200">
          <thead>
            <tr>
              <th>SKU</th>
              <th>Amount</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-200 align-text-top">
            <tr>
              <td class="font-bold">{{ itemToBeCancelled.SKU }}</td>
              <td class="text-center">{{ itemToBeCancelled.PricePerUnit | money }}</td>
              <td class="text-center">{{ itemToBeCancelled.Product }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="sm:col-span-6">
        <label
          :for="`note-${_uid}`"
          class="block text-sm font-medium leading-5 text-gray-700"
        >
          Note
        </label>
        <div class="mt-1 rounded-md shadow-sm">
          <textarea
            :id="`note-${_uid}`"
            v-model="note"
            rows="3"
            class="form-textarea block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
          ></textarea>
        </div>
      </div>
    </div>

    <HttpError :error="error" />

    <!-- Footer -->
    <div class="flex justify-end px-4 py-4 space-x-4">
      <span class="inline-flex rounded-md shadow-sm">
        <button
          type="button"
          @click="toggleSlideover()"
          class="py-2 px-4 border border-gray-300 rounded-md text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-50 active:text-gray-800 transition duration-150 ease-in-out"
        >
          Cancel
        </button>
      </span>
      <span class="inline-flex rounded-md shadow-sm">
        <Button
          @click-handler="process"
          :disabled="!canProcess || processing"
          class="flex items-center space-x-2"
        >
          <span>Cancel Adjustment</span>
          <LoadingSpinner v-if="processing" class="text-white" />
        </Button>
      </span>
    </div>
  </Slideover>
</template>
<script>
import { ApiFactory } from "@/api/ApiFactory.js";
import moneyFormatter from "@/mixins/moneyFormatter";
import Button from "@/components/elements/Button.vue";
import Slideover from "@/components/layout/Slideover.vue";

const Order = ApiFactory.get("orders");

export default {
  name: "CancelAdjustment",
  components: {
    Button,
    Slideover,
  },
  filters: {
    money: moneyFormatter.format
  },
  props: {
    title: {
      type: String,
      default: "Title",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    itemToBeCancelled: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      note: null,
      error: null,
      processing: false,
    };
  },
  computed: {
    canProcess() {
      if (!this.note) {
        return false;
      }

      return true;
    },
  },
  methods: {
    process() {
      this.processing = true;
      this.error = null;

      Order.cancelAdjustment(
          this.itemToBeCancelled.order.SourceOrderNumber,
          this.itemToBeCancelled.ItemNumber,
          {
            note: this.note,
          }
        )
        .then(this.handleSuccess)
        .catch((error) => (this.error = error))
        .finally(() => (this.processing = false));
    },
    handleSuccess() {
      this.toggleSlideover();
      this.$emit("refresh-order");
    },
    toggleSlideover(){
      this.$emit("toggle-slideover");
      this.resetData();
    },
    resetData(){
      setTimeout(() => {
        this.note = null;
        this.error = null;
        this.processing = false;
      }, 1000);
    },
  },
};
</script>
<style scoped lang="scss">
th {
  @apply px-2 py-2 bg-gray-200 text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider;
}

td {
  @apply px-2 py-1 whitespace-no-wrap text-sm leading-5;
}

table {
  @apply text-gray-500;
}
</style>
